import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { PhulkariBorder } from './ui/Ornaments';
export const SkillsGrid = () => {
  const skills = [{
    name: 'Public Speaking',
    desc: 'Command a room and articulate your vision clearly.'
  }, {
    name: 'AI Research',
    desc: 'Leverage LLMs to accelerate data gathering and synthesis.'
  }, {
    name: 'Entrepreneurship',
    desc: 'Understand viability, feasibility, and desirability.'
  }, {
    name: 'Root Cause Analysis',
    desc: 'Look past symptoms to find the structural issue.'
  }, {
    name: 'Stakeholder Mapping',
    desc: 'Identify who holds power and who is impacted.'
  }, {
    name: 'Pitching',
    desc: 'Distill complex ideas into a compelling 3-minute narrative.'
  }, {
    name: 'Strategic Writing',
    desc: 'Draft clear, persuasive memos and executive summaries.'
  }];
  return <section className="py-24 bg-parchment relative" data-id="element-233">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-234" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-235">
        <SectionHeader title="Skills you leave with." subtitle="We focus on hard, transferable skills that will serve you in university and your career." data-id="element-236" />

        <div className="flex flex-wrap gap-4" data-id="element-237">
          {skills.map((skill, idx) => <motion.div key={skill.name} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.05
        }} whileHover={{
          scale: 1.05,
          y: -2
        }} className="group relative bg-ivory border border-bronze/20 px-6 py-4 rounded-sm hover:border-kesari hover:bg-kesari/5 hover:shadow-md transition-all cursor-default" data-id="element-238">
              <span className="font-sans text-navy font-medium group-hover:text-kesari transition-colors" data-id="element-239">
                {skill.name}
              </span>

              {/* Tooltip on hover */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-3 w-56 p-4 bg-navy text-ivory text-xs font-sans rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-20 shadow-xl" data-id="element-240">
                <div className="text-kesari mb-1 font-serif text-lg" data-id="element-241">✦</div>
                {skill.desc}
                <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-navy" data-id="element-242" />
              </div>
            </motion.div>)}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-2 text-kesari/20" data-id="element-243">
        <PhulkariBorder className="w-full h-full" data-id="element-244" />
      </div>
    </section>;
};